import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-catalogs-new-preparation',
  templateUrl: './catalogs-new-preparation.component.html',
  styleUrls: ['./catalogs-new-preparation.component.scss']
})
export class CatalogsNewPreparationComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
